

































































































































































import Vue from 'vue';
import ClipboardTextOutline from 'vue-material-design-icons/ClipboardTextOutline.vue';
import Camera from 'vue-material-design-icons/Camera.vue';
import ArrowLeft from 'vue-material-design-icons/ArrowLeft.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    ClipboardTextOutline,
    Camera,
    ArrowLeft,
    pxButton,
  },
  props: {
    essayId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showPicture: false,
      sentImage: null,
      sending: false,
    };
  },
  computed: {
    isRNWebView: function() {
      return window.isRNWebView == true;
    },
  },
  methods: {
    tabColor(index: number): string {
      if (this.showPicture) {
        return ['#212121', '#00C974'][index];
      } else {
        return ['#00C974', '#212121'][index];
      }
    },
    triggerInput() {
      document.getElementById('photoInput').click();
      this.showPicture = true;
    },
    readFileAsync(file: File) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    async handleFiles(event: Event) {
      let photo = (event.target as HTMLInputElement).files[0];
      this.sentImage = await this.readFileAsync(photo);
    },
    async clearPicture() {
      this.showPicture = false;
      this.sentImage = null;
    },
    async sendEssay() {
      this.sending = true;
      let imageURL = await this.$store.dispatch('UPLOAD_IMAGE', this.sentImage);
      await this.$store.dispatch('CREATE_AND_ASSOCIATE_IMAGE', {
        url: imageURL,
        essayId: this.essayId,
      });
      await this.$store.dispatch('PUSH_ESSAY', this.essayId);
      this.$emit('sentEssay');
    },
  },
});
